/*@flow*/
import { createContext } from 'react';

export const ChartDeckContext = createContext<{
  addMapTiles: Function,
  removeMapTiles: Function,
}>({
  addMapTiles: () => {},
  removeMapTiles: () => {},
});
